import { render, staticRenderFns } from "./btn-border-radius.vue?vue&type=template&id=db445eba&scoped=true"
import script from "./btn-border-radius.vue?vue&type=script&lang=js"
export * from "./btn-border-radius.vue?vue&type=script&lang=js"
import style0 from "./btn-border-radius.vue?vue&type=style&index=0&id=db445eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db445eba",
  null
  
)

export default component.exports